/* eslint-disable  */
import { debounce } from "lodash";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import React, { useEffect, useState } from "react";
import { BsCartPlus } from "react-icons/bs";
import { MdFavorite, MdOutlineFavoriteBorder } from "react-icons/md";
import OwlCarousel from "react-owl-carousel";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link, useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import "../../../../css/Pages/Shopping.css";
import {
  productActionCreators,
  userDataActionCreators,
} from "../../../../service/action-creators";
import { GetUserProfile } from "../../../../service/action-creators/authAction";
import { GetNotifications } from "../../../../service/action-creators/notificationAction";
import Loader from "../../../Loader";
import RenderHome from "../../home/RenderHome";
import "./Products.css";
import AddToCartModal from "./sub_component/AddToCartModal";
import { Phone, ShoppingBasket } from "@material-ui/icons";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

function Products() {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    GetFeaturedProduct,
    GetElectronicesCategory,
    GetComputingCategory,
    GetTelevisionCategory,
    GetHomeAndAppliancesCategory,
    GetLatexFoamProducts,
    GetPolyTankProducts,
    GetProductCategory,
    GetBannerProducts,
    ResetProductResponse,
  } = bindActionCreators(productActionCreators, dispatch);
  const {
    AddFavoriteProducts,
    AddProductToCart,
    ResetUserDataResponse,
    GetCartProducts,
    GetFavoriteProducts,
  } = bindActionCreators(userDataActionCreators, dispatch);

  const product = useSelector((state) => state?.product);
  const user = useSelector((state) => state?.user);

  const isLoading = product?.isLoading;
  const featuredProduct = product?.featured;
  const electronicsCategory = product?.electronicsCategory;
  const computingProducts = product?.computingProducts;
  const televisionProducts = product?.televisionProducts;
  const homeAndApplianceProducts = product?.homeAndApplianceProducts;
  const latexFoamProducts = product?.latexFoamProducts;
  const polyTankProducts = product?.polyTankProducts;
  const category = product?.category;
  const carts = user?.cart;

  const favProducts = user.favoriteProducts;
  const favProductIds = [];
  favProducts.map((fav) => favProductIds.push(fav?.product_id?._id));

  const electronics = "Electronics";
  const homeAndAppliance = "Home & Appliances";
  const latexFoamCategory = "MATTRESSES and Furniture";
  const polyTankCategory = "TANKS";

  const [search, setSearch] = useState("");
  const [cartModalProduct, setCartModalProduct] = useState(null);

  const handleChange = debounce((e) => {
    if (e.target.value) {
      setSearch(e.target.value ?? null);
    } else {
      setSearch(null);
    }
  }, 800);

  const handleBannerItemClick = (product) => {
    history.push({
      pathname: "/product-detailed",
      state: { product: product },
    });
  };

  // Shared add-to-cart helper — opens the term selection modal
  const handleAddToCart = (e, prod) => {
    e.stopPropagation();
    e.preventDefault();
    setCartModalProduct(prod);
  };

  const handleModalAdd = (payload) => {
    AddProductToCart(payload);
  };

  // keep old block below just to satisfy any stale references — will be dead code
  const _legacyAddToCart = (prod) => {
    if (carts?.length > 0) {
      let selectedDuration;
      let percentChange;
      if (Number(carts[0]?.period) === 18) {
        percentChange = 1.145;
        selectedDuration = Number(carts[0]?.period);
      } else if (
        Number(carts[0]?.period) === 3 ||
        Number(carts[0]?.period) === 6 ||
        Number(carts[0]?.period) === 12
      ) {
        percentChange = 1.1;
        selectedDuration = Number(carts[0]?.period);
      }
      const adminCharge = 3 / 100;
      const retailPrice = Number(prod?.new_price);
      const adminAmount = retailPrice * adminCharge;
      const initialAmount = retailPrice * percentChange + adminAmount;
      const selectedPeriod = Number(initialAmount / selectedDuration).toFixed(2);
      AddProductToCart({
        size: "",
        color: "",
        quantity: 1,
        product_id: prod?._id,
        period: selectedDuration,
        period_price: selectedPeriod,
      });
    } else {
      const defaultDuration = 3;
      const percentChange = 1.1;
      const adminCharge = 3 / 100;
      const retailPrice = Number(prod?.new_price);
      const adminAmount = retailPrice * adminCharge;
      const initialAmount = retailPrice * percentChange + adminAmount;
      const selectedPeriod = Number(initialAmount / defaultDuration).toFixed(2);
      AddProductToCart({
        size: "",
        color: "",
        quantity: 1,
        product_id: prod?._id,
        period: defaultDuration,
        period_price: selectedPeriod,
      });
    }
  };

  useEffect(() => {
    GetProductCategory();
    GetFeaturedProduct();
    GetComputingCategory("Computing & Phones", 10);
    GetTelevisionCategory("Televisions", 10);
    GetElectronicesCategory(electronics, 5);
    GetHomeAndAppliancesCategory(homeAndAppliance, 5);
    GetLatexFoamProducts(latexFoamCategory, 10);
    GetPolyTankProducts(polyTankCategory, 10);
    dispatch(GetUserProfile());
    dispatch(GetNotifications());
    GetCartProducts();
    GetBannerProducts();
    GetFavoriteProducts();
  }, []);

  useEffect(() => {
    if (
      user.response?.state === "SUCCESS" ||
      product?.response?.state === "SUCCESS"
    ) {
      GetCartProducts();
      GetFavoriteProducts();
      setTimeout(() => {
        ResetUserDataResponse();
        ResetProductResponse();
      }, 1500);
    } else if (
      user?.response?.state === "ERROR" ||
      product?.response?.state === "ERROR"
    ) {
      setTimeout(() => {
        ResetProductResponse();
        ResetProductResponse();
      }, 1500);
    }
  }, [user?.response?.state || product?.response.state]);

  const device = () => window.innerWidth < 1080;
  const [isMobile, setIsMobile] = useState(device);

  useEffect(() => {
    window.addEventListener("resize", () => setIsMobile(device));
    window.scrollTo({ top: 0, behavior: "smooth" });
    return () => {};
  }, []);

  return (
    <div className="ProductsPage">
      <RenderHome>
        {isLoading || (user?.isLoading && <Loader />)}

        {/* ── SEARCH BAR ─────────────────────────────────── */}
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="search-wrapper">
            <span style={{ color: "#aaa", fontSize: "1.1rem", lineHeight: 1 }}>🔍</span>
            <input
              type="search"
              placeholder="Search product by name..."
              name="search"
              defaultValue={search}
              onChange={handleChange}
            />
            <button
              type="button"
              className="search-btn"
              onClick={() =>
                search &&
                history.push({
                  pathname: "/searchedProducts",
                  state: { searchValue: search },
                })
              }
            >
              Search
            </button>
          </div>
        </form>

        {/* ── SHOWCASE: Sidebar + Banner + Info ──────────── */}
        <section className="productShowcaseWrapper">
          {/* Left Sidebar – Categories (KEEP) */}
          <div className="sideOne">
            <div className="header">Categories</div>
            <hr />
            <ul>
              <li onClick={() => history.push(`/category-products?query=featured`)}>
                Featured Products
              </li>
              <li onClick={() => history.push(`/category-products?query=Electronics`)}>
                Electronics
              </li>
              <li onClick={() => history.push(`/category-products?query=Computing & Phones`)}>
                Computing & Phones
              </li>
              <li onClick={() => history.push(`/category-products?query=Home & Appliances`)}>
                Home & Appliances
              </li>
              <li onClick={() => history.push(`/category-products?query=Televisions`)}>
                Televisions
              </li>
              <li onClick={() => history.push(`/category-products?query=${latexFoamCategory}`)}>
                Mattresses & Furniture
              </li>
              <li onClick={() => history.push(`/category-products?query=${polyTankCategory}`)}>
                Tanks
              </li>
              <li>Computing & Accessories</li>
            </ul>
          </div>

          {/* Center Banner Carousel */}
          <div className="ProductSlider">
            <Carousel autoPlay interval={5000} showThumbs={false} infiniteLoop>
              {product?.banner?.map((p, index) => (
                <div key={index} onClick={() => handleBannerItemClick(p)} style={{ cursor: "pointer" }}>
                  <img src={p.banner_image} alt={p.title} />
                </div>
              ))}
            </Carousel>
          </div>

          {/* Right Info Panel */}
          <div className="sideThree">
            <div className="info">
              <div className="item">
                <Phone className="icon" />
                <div className="content">
                  <div className="font-bold">CALL THE MART</div>
                  <div>0372099642</div>
                </div>
              </div>
              <div className="item">
                <ShoppingBasket className="icon" />
                <div className="content">
                  <div className="font-bold">VIEW YOUR CART</div>
                  <div style={{ cursor: "pointer" }} onClick={() => history.push("/my-cart")}>
                    Check your cart
                  </div>
                </div>
              </div>
              <div className="item">
                <BsCartPlus style={{ fontSize: "1.4rem" }} className="icon" />
                <div className="content">
                  <div className="font-bold">REQUEST ORDER</div>
                  <div style={{ cursor: "pointer" }} onClick={() => history.push("/request-order")}>
                    Request now
                  </div>
                </div>
              </div>
            </div>
            <div className="smallBanner">
              <img
                className="cursor-pointer"
                onClick={() => handleBannerItemClick(product?.banner[0])}
                src={product?.banner[0]?.banner_image}
                alt={product?.banner[0]?.title}
              />
            </div>
          </div>
        </section>

        {/* ── FEATURED PRODUCTS (OwlCarousel) ─────────────── */}
        <section className="featuredSection">
          <div className="header">
            <div className="topBar">
              <div>Featured Products</div>
              <div
                className="section-see-all"
                onClick={() => history.push(`/category-products?query=featured`)}
              >
                See All →
              </div>
            </div>
          </div>
          <div className="items">
            <OwlCarousel
              className="owl-theme owl-carousel-mobile"
              id="owl-carousel"
              loop
              margin={10}
              style={{ width: "100%" }}
              autoplay
              dots
              dotsClass="owl-dots-custom"
              items={!isMobile ? 5 : 2}
              nav={true}
            >
              {featuredProduct?.map((feat, index) => (
                <div className="itemContainer" key={index}>
                  <Link to={{ pathname: `/product-detailed`, state: { product: feat } }}>
                    <div className="imgCover">
                      <img className="image" src={feat?.images[0]?.url} alt="product" />
                    </div>
                    <div className="info">
                      <p className="short_decription">
                        {feat?.product_name.length <= 55
                          ? feat?.product_name
                          : feat?.product_name.slice(0, 55) + "..."}
                      </p>
                      <p>
                        <span className="new_price">&#8373; {feat?.new_price}</span>{" "}
                        <span className="old_price">{feat?.old_price}</span>
                      </p>
                    </div>
                  </Link>
                  <button
                    className="owl-add-btn"
                    onClick={(e) => handleAddToCart(e, feat)}
                  >
                    <BsCartPlus /> Add to Cart
                  </button>
                </div>
              ))}
            </OwlCarousel>
          </div>
        </section>

        {/* ── ELECTRONICS (Grid) ─────────────────────────── */}
        <section className="vehicles_section">
          <div className="vehicles_section_cover">
            <div className="header">
              <div className="topBar">
                <div>{electronics}</div>
                <div
                  className="section-see-all"
                  onClick={() => history.push(`/category-products?query=${electronics}`)}
                >
                  See All →
                </div>
              </div>
            </div>
            <div className="box_container_grid">
              {electronicsCategory?.map((prod, index) => (
                <div
                  key={index}
                  className="box"
                  onClick={() => history.push({ pathname: "/product-detailed", state: { product: prod } })}
                >
                  <div className="imgCover">
                    <span className="percent_off">{prod?.percent}%</span>
                    <div className="imgMainCover">
                      <img src={prod?.images[0]?.url} alt="product" />
                    </div>
                  </div>
                  <div className="descr_price">
                    <div className="descr">
                      {prod?.product_name.length <= 55 ? prod?.product_name : prod?.product_name.slice(0, 55) + "..."}
                    </div>
                    <div className="price">
                      Gh&#8373;{prod?.new_price}
                      {prod?.old_price && (
                        <span className="old-price"> &#8373;{prod?.old_price}</span>
                      )}
                    </div>
                  </div>
                  <div className="box-actions">
                    <button
                      className="box-add-btn"
                      onClick={(e) => handleAddToCart(e, prod)}
                    >
                      <BsCartPlus /> Add to Cart
                    </button>
                    <button
                      className={`box-fav-btn ${favProductIds?.includes(prod?._id) ? "active" : ""}`}
                      onClick={(e) => { e.stopPropagation(); AddFavoriteProducts(prod?._id); }}
                    >
                      {favProductIds?.includes(prod?._id) ? <MdFavorite /> : <MdOutlineFavoriteBorder />}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── MATTRESSES & FURNITURE (OwlCarousel) ────────── */}
        <section className="featuredSection">
          <div className="header">
            <div className="topBar">
              <div>Mattresses & Furniture</div>
              <div
                className="section-see-all"
                onClick={() => history.push(`/category-products?query=${latexFoamCategory}`)}
              >
                See All →
              </div>
            </div>
          </div>
          <div className="items">
            <OwlCarousel
              className="owl-theme owl-carousel-mobile"
              id="owl-carousel"
              loop
              margin={10}
              style={{ width: "100%" }}
              autoplay
              dots
              dotsClass="owl-dots-custom"
              items={!isMobile ? 5 : 2}
              nav={true}
            >
              {latexFoamProducts?.map((prod, index) => (
                <div className="itemContainer" key={index}>
                  <Link to={{ pathname: `/product-detailed`, state: { product: prod } }}>
                    <div className="imgCover">
                      <img className="image" src={prod?.images[0]?.url} alt="product" />
                    </div>
                    <div className="info">
                      <p className="short_decription">
                        {prod?.product_name.length <= 55 ? prod?.product_name : prod?.product_name.slice(0, 55) + "..."}
                      </p>
                      <p>
                        <span className="new_price">&#8373; {prod?.new_price}</span>{" "}
                        <span className="old_price">{prod?.old_price}</span>
                      </p>
                    </div>
                  </Link>
                  <button className="owl-add-btn" onClick={(e) => handleAddToCart(e, prod)}>
                    <BsCartPlus /> Add to Cart
                  </button>
                </div>
              ))}
            </OwlCarousel>
          </div>
        </section>

        {/* ── HOME & APPLIANCES (Grid) ────────────────────── */}
        <section className="vehicles_section">
          <div className="vehicles_section_cover">
            <div className="header">
              <div className="topBar">
                <div>{homeAndAppliance}</div>
                <div
                  className="section-see-all"
                  onClick={() => history.push(`/category-products?query=${homeAndAppliance}`)}
                >
                  See All →
                </div>
              </div>
            </div>
            <div className="box_container_grid">
              {homeAndApplianceProducts?.map((prod, index) => (
                <div
                  key={index}
                  className="box"
                  onClick={() => history.push({ pathname: "/product-detailed", state: { product: prod } })}
                >
                  <div className="imgCover">
                    <span className="percent_off">{prod?.percent}%</span>
                    <div className="imgMainCover">
                      <img src={prod?.images[0]?.url} alt="product" />
                    </div>
                  </div>
                  <div className="descr_price">
                    <div className="descr">
                      {prod?.product_name.length <= 55 ? prod?.product_name : prod?.product_name.slice(0, 55) + "..."}
                    </div>
                    <div className="price">
                      Gh&#8373;{prod?.new_price}
                      {prod?.old_price && <span className="old-price"> &#8373;{prod?.old_price}</span>}
                    </div>
                  </div>
                  <div className="box-actions">
                    <button className="box-add-btn" onClick={(e) => handleAddToCart(e, prod)}>
                      <BsCartPlus /> Add to Cart
                    </button>
                    <button
                      className={`box-fav-btn ${favProductIds?.includes(prod?._id) ? "active" : ""}`}
                      onClick={(e) => { e.stopPropagation(); AddFavoriteProducts(prod?._id); }}
                    >
                      {favProductIds?.includes(prod?._id) ? <MdFavorite /> : <MdOutlineFavoriteBorder />}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── TANKS (Grid) ──────────────────────────────────── */}
        <section className="vehicles_section">
          <div className="vehicles_section_cover">
            <div className="header">
              <div className="topBar">
                <div>Tanks</div>
                <div
                  className="section-see-all"
                  onClick={() => history.push(`/category-products?query=${polyTankCategory}`)}
                >
                  See All →
                </div>
              </div>
            </div>
            <div className="box_container_grid">
              {polyTankProducts?.map((prod, index) => (
                <div
                  key={index}
                  className="box"
                  onClick={() => history.push({ pathname: "/product-detailed", state: { product: prod } })}
                >
                  <div className="imgCover">
                    <span className="percent_off">{prod?.percent}%</span>
                    <div className="imgMainCover">
                      <img src={prod?.images[0]?.url} alt="product" />
                    </div>
                  </div>
                  <div className="descr_price">
                    <div className="descr">
                      {prod?.product_name.length <= 55 ? prod?.product_name : prod?.product_name.slice(0, 55) + "..."}
                    </div>
                    <div className="price">
                      Gh&#8373;{prod?.new_price}
                      {prod?.old_price && <span className="old-price"> &#8373;{prod?.old_price}</span>}
                    </div>
                  </div>
                  <div className="box-actions">
                    <button className="box-add-btn" onClick={(e) => handleAddToCart(e, prod)}>
                      <BsCartPlus /> Add to Cart
                    </button>
                    <button
                      className={`box-fav-btn ${favProductIds?.includes(prod?._id) ? "active" : ""}`}
                      onClick={(e) => { e.stopPropagation(); AddFavoriteProducts(prod?._id); }}
                    >
                      {favProductIds?.includes(prod?._id) ? <MdFavorite /> : <MdOutlineFavoriteBorder />}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── COMPUTING & PHONES (Grid) ───────────────────── */}
        <section className="vehicles_section">
          <div className="vehicles_section_cover">
            <div className="header">
              <div className="topBar">
                <div>Computing & Phones</div>
                <div
                  className="section-see-all"
                  onClick={() => history.push(`/category-products?query=Computing & Phones`)}
                >
                  See All →
                </div>
              </div>
            </div>
            <div className="box_container_grid">
              {computingProducts?.slice(0, 10).map((prod, index) => (
                <div
                  key={index}
                  className="box"
                  onClick={() => history.push({ pathname: "/product-detailed", state: { product: prod } })}
                >
                  <div className="imgCover">
                    <span className="percent_off">{prod?.percent}%</span>
                    <div className="imgMainCover">
                      <img src={prod?.images[0]?.url} alt="product" />
                    </div>
                  </div>
                  <div className="descr_price">
                    <div className="descr">
                      {prod?.product_name.length <= 55 ? prod?.product_name : prod?.product_name.slice(0, 55) + "..."}
                    </div>
                    <div className="price">Gh&#8373;{prod?.new_price}</div>
                  </div>
                  <div className="box-actions">
                    <button className="box-add-btn" onClick={(e) => handleAddToCart(e, prod)}>
                      <BsCartPlus /> Add to Cart
                    </button>
                    <button
                      className={`box-fav-btn ${favProductIds?.includes(prod?._id) ? "active" : ""}`}
                      onClick={(e) => { e.stopPropagation(); AddFavoriteProducts(prod?._id); }}
                    >
                      {favProductIds?.includes(prod?._id) ? <MdFavorite /> : <MdOutlineFavoriteBorder />}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── TELEVISIONS (OwlCarousel) ────────────────────── */}
        <section className="featuredSection">
          <div className="header">
            <div className="topBar">
              <div>Televisions</div>
              <div
                className="section-see-all"
                onClick={() => history.push(`/category-products?query=Televisions`)}
              >
                See All →
              </div>
            </div>
          </div>
          <div className="items">
            <OwlCarousel
              className="owl-theme owl-carousel-mobile"
              id="owl-carousel"
              loop
              margin={10}
              style={{ width: "100%" }}
              autoplay
              dots
              dotsClass="owl-dots-custom"
              items={!isMobile ? 5 : 2}
              nav={true}
            >
              {televisionProducts?.map((prod, index) => (
                <div className="itemContainer" key={index}>
                  <Link to={{ pathname: `/product-detailed`, state: { product: prod } }}>
                    <div className="imgCover">
                      <img className="image" src={prod?.images[0]?.url} alt="product" />
                    </div>
                    <div className="info">
                      <p className="short_decription">
                        {prod?.product_name.length <= 55 ? prod?.product_name : prod?.product_name.slice(0, 55) + "..."}
                      </p>
                      <p>
                        <span className="new_price">&#8373; {prod?.new_price}</span>{" "}
                        <span className="old_price">{prod?.old_price}</span>
                      </p>
                    </div>
                  </Link>
                  <button className="owl-add-btn" onClick={(e) => handleAddToCart(e, prod)}>
                    <BsCartPlus /> Add to Cart
                  </button>
                </div>
              ))}
            </OwlCarousel>
          </div>
        </section>

        {cartModalProduct && (
          <AddToCartModal
            product={cartModalProduct}
            carts={carts}
            onAdd={handleModalAdd}
            onClose={() => setCartModalProduct(null)}
          />
        )}

        <ToastContainer autoClose={3000} />
      </RenderHome>
    </div>
  );
}

export default Products;
